var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 37,
    height: 36.659,
    viewBox: "0 0 37 36.659",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 37,
    height: 36.659,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "facebook",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M37,36.659H0V0H37V36.659M31.524,4.287a3.236,3.236,0,0,0-.433-.059c-1.6.011-3.2-.057-4.8.061-2.7.2-4.82,1.44-5.218,4.735a32.034,32.034,0,0,0-.119,4.113c.005.572-.195.729-.729.7-.634-.031-1.271.008-1.907-.005-.343-.007-.48.119-.477.468.011,1.355.008,2.71,0,4.065,0,.293.1.41.405.4.655-.013,1.314.039,1.964-.012.6-.046.746.163.743.737-.022,4.448,0,8.9-.021,13.343,0,.474.128.621.611.612,1.6-.027,3.2-.008,4.8-.011.184,0,.367-.028.578-.045v-.747c0-4.391.014-8.781-.011-13.171,0-.6.189-.749.757-.724.961.042,1.926,0,2.889.019.358.006.5-.1.532-.481.073-.949.2-1.893.305-2.841.056-.52.1-1.042.147-1.616h-.65c-1.136,0-2.273.014-3.409-.016-.186-.005-.524-.2-.526-.318-.016-1.047-.017-2.1.067-3.142a1.071,1.071,0,0,1,1.117-1.1c.9-.084,1.805-.077,2.708-.111.222-.008.444-.02.677-.031Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.e4a34c01d048652d874beded126707b6.svg";
export { ForwardRef as ReactComponent };